<template>
<div class="bk-choice">
  <bk-input-label>{{label}}</bk-input-label>
  <div class="bk-choice__list">
    <div class="bk-choice__item" v-for="choice in choices">
      <input :id="getId(choice.id)"
             :checked="value === choice.value"
             @input="$emit('input',$event.target.value)"
             :name="name"
             type="radio"
             :value="choice.value"
      >
      <label class="bk-choice__item__label" :for="getId(choice.id)">{{choice.text}}</label>
    </div>
  </div>
</div>
</template>
<script>
import BkInputLabel from './BkInputLabel'

export default {
  name: 'bk-choice',
  components: { BkInputLabel },
  props: {
    label: String,
    choices: Array,
    value: {},
    name: String
  },
  methods: {
    /**
     * return a id with the current value and the component name
     * @param id
     * @returns {string}
     */
    getId (id) {
      return `${this.name}-${id}`
    },
  },
}
</script>


<style lang="scss" scoped>
  @import "../scss/colors";

  .bk-choice {
    &__item {
      height: 40px;
      border: 2px solid $primary;
      display: inline-block;
      width: 50%;
      box-sizing: border-box;
      text-align: center;

      &:first-of-type {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }

      &:last-of-type {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        border-left: none;

      }

      &__label {
        color: $primary;
        height: 100%;
        width: 100%;
        display: flex;
        cursor: pointer;
        justify-content: center;
        align-items: center;
      }
    }

    input[type="radio"] {
      display: none;

      &:checked + .bk-choice__item__label {
        background-color: $primary;
        color: $on-primary;
      }
    }
  }
</style>
